/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_Retention_12_MonthsInputs */

const tr_cerez_retention_12_months = /** @type {(inputs: Cerez_Retention_12_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ay`)
};

const en_cerez_retention_12_months = /** @type {(inputs: Cerez_Retention_12_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 months`)
};

const de_cerez_retention_12_months = /** @type {(inputs: Cerez_Retention_12_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 Monate`)
};

const ru_cerez_retention_12_months = /** @type {(inputs: Cerez_Retention_12_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 месяцев`)
};

/**
* | output |
* | --- |
* | "12 months" |
*
* @param {Cerez_Retention_12_MonthsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_retention_12_months = /** @type {((inputs?: Cerez_Retention_12_MonthsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_Retention_12_MonthsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_retention_12_months(inputs)
	if (locale === "de") return de_cerez_retention_12_months(inputs)
	if (locale === "ru") return ru_cerez_retention_12_months(inputs)
	return tr_cerez_retention_12_months(inputs)
});